import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite/no-important';

const propTypes = {
  heroImg: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  showMask: PropTypes.bool,
  maskBg: PropTypes.string,
  maskOpacity: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

const defaultProps = {
  heroImg: 'https://via.placeholder.com/1920x1080',
  className: '',
  showMask: false,
  style: {},
  maskBg: '#000',
  maskOpacity: 0.75
};

const Hero = (props) => {
  const styles = StyleSheet.create({
    hero: {
      position: 'relative',
      display: 'flex',
      width: '100vw; ',
      alignItems: 'center',
      flexFlow: 'column nowrap',
      justifyContent: 'center'
    },
    heroImg: {
      width: '100%',
      height: 'auto',
      objectFit: 'cover',
      overflow: 'hidden'
    },
    heroMask: {
      position: 'absolute',
      top: '0',
      height: '100%',
      width: '100%',
      background: props.maskBg,
      opacity: `${props.maskOpacity}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    maskText: {
      color: 'white',
      textDecoration: 'underline',
      fontSize: '80px'
    }
  });

  return (
    <div
    className={`${props.className} ${css(styles.hero)}`}
    style={{ ...props.style }}
  >
    {props.showMask
      ? <div className={css(styles.heroMask)}>
          <h1 className={css(styles.maskText)}>Hello World</h1>
      </div>
      : null
    }
    <img
      alt="Hero"
      src={props.heroImg}
      className={`img-fluid ${css(styles.heroImg)}`}
    />
    {props.children}
  </div>
  );
};

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;
export { Hero };
